import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { isNil } from 'lodash'

import { useGetFollowersQuery } from 'store/api/yay/user'
import { appendList } from 'lib/helpers'
import { useInfinityScrollSimple } from 'hooks'

import Modal from 'components/Modal/Modal'
import LoadMore from 'components/LoadMore'
import { UserList } from 'components'

const MutualFollowingModal = ({
  userId,
  isActive,
  onClose,
}: {
  isActive: boolean
  onClose: Function
  userId: number
}) => {
  const { t } = useTranslation()

  const [__followers, __followersSet] = useState([])
  const [__fromFollowId, __fromFollowIdSet] = useState<string>('0')

  const followersRes = useGetFollowersQuery({
    userId,
    followedByMe: true,
    fromFollowId: __fromFollowId,
  })

  const loadMore = () => {
    __fromFollowIdSet(followersRes?.data?.last_follow_id?.toString?.())
  }

  const { loadMoreRef } = useInfinityScrollSimple({
    loadMore,
  })

  useEffect(() => {
    __followersSet((prevState) => {
      return appendList(prevState, followersRes?.data?.users)
    })
  }, [followersRes])

  return (
    <Modal
      onClose={onClose}
      isActive={isActive}
      title={t('mutual_following_modal.title')}
    >
      <UserList
        users={__followers || []}
        followCallbackSetter={__followersSet}
      />

      <LoadMore
        isLoading={followersRes?.isFetching}
        hidden={isNil(followersRes?.data?.last_follow_id)}
        className="LoadMore--bd-t"
        onClick={() => {
          loadMore()
        }}
        ref={loadMoreRef}
      />
    </Modal>
  )
}

export default MutualFollowingModal
